import { environment } from '@environments/environment';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  template: ''
})
export class SignUpRedirectComponent {
  ngOnInit() {
    window.location.href = environment.signUpUrl;
  }
}

